// extracted by mini-css-extract-plugin
module.exports = {"page":"VBPQzUEx","content":"_17FW4VtB","neighbour":"qmmzXTND","item":"_24ZPCWnY","active":"_3f9Fq_mM","current":"_3F3iJArx","title":"_3E9PjbUK","view":"sxVTHT0c"};